import FavoriteService from "@/services/favorite.service";
import ToastService from "@/services/toast.service";

export const favorite = {
    namespaced: true,
    state:{
        groups:[],
        items:[]
    },
    mutations:{
        setGroups(state, groups){
            state.groups = groups;
        },
        setItems(state, items){
            state.items = items;
        },
        REMOVE_GROUP(state, groupId) {
            state.groups = state.groups.filter(
                group => group.id !== groupId
            );
        },
        UPDATE_GROUP(state, group) {
            const index = state.groups.findIndex(
                item => item.id === group.id
            );

            if (index !== -1) {
                state.groups[index] = {
                    ...state.groups[index],
                    ...group
                };
            }
        },
        REORDER_GROUPS(state, { draggedId, targetId }) {
            const draggedIndex = state.groups.findIndex(group => group.id === draggedId);
            const targetIndex = state.groups.findIndex(group => group.id === targetId);
            if (draggedIndex === -1 || targetIndex === -1) {
                return;
            }

            const [dragged] = state.groups.splice(draggedIndex, 1);
            state.groups.splice(targetIndex, 0, dragged);
            state.groups.forEach((group, index) => { group.sortOrder = index + 1; });
        },
        INCREMENT_GROUP_COUNT(state, groupId) {
            const group = state.groups.find(
                group => group.id === groupId
            );

            if (group) {
                group.count++;
            }
        },
        DECREMENT_GROUP_COUNT(state, groupId) {
            const group = state.groups.find(
                group => group.id === groupId
            );

            if (group && group.count > 0) {
                group.count--;
            }
        },
        setItemFileExists(
            state,
            {
                itemId,
                fileExists
            }
        ) {
            for (const group of state.groups) {
                if (!group.items)
                    continue;

                const item =
                    group.items.find(
                        item => item.id === itemId
                    );

                if (item) {
                    item.fileExists = fileExists;
                    return;
                }
            }
        }
    },
    actions:{
        async loadGroups({commit}){
            const groups = await FavoriteService.getGroups();
            commit("setGroups", groups);
        },
        async loadItems({ commit }, groupId) {            
            const items = await FavoriteService.getItems(groupId);
            commit("setItems", items);

            return items;
        },
        async createGroup({ dispatch }, name){
            await FavoriteService.createGroup(name);
            await dispatch("loadGroups");
        },
        async addFavorite({ commit, dispatch}, payload){
            await FavoriteService.addFavorite(payload.groupId, payload.files);
            commit(
                "INCREMENT_GROUP_COUNT",
                payload.groupId
            );

            await dispatch("loadItems", payload.groupId);
        },
        async deleteItem({ commit, dispatch }, payload){
            await FavoriteService.deleteItem(
                payload.groupId,
                payload.itemId,
                payload.autoDelete === true
            );

            commit(
                "DECREMENT_GROUP_COUNT",
                payload.groupId
            );

            if (payload.autoDelete) {
                ToastService.info(
                    `"${payload.itemName}" 파일이 존재하지 않아 즐겨찾기에서 삭제되었습니다.`,
                    {
                        autoClose: 10000
                    }
                );
            }

            await dispatch("loadItems", payload.groupId);
        },
        async renameGroup({ commit }, payload) {
            const response = await FavoriteService.renameGroup(payload.id, payload.name);
            if (response.status === 200) {
                commit("UPDATE_GROUP", response.data);
            }
        },
        async deleteGroup({ commit }, groupId) {
            const response = await FavoriteService.deleteGroup(groupId);
            if (response.status === 204) {
                commit("REMOVE_GROUP", groupId);
            }
        },
        async reorderGroups({ dispatch }, payload) {
            const response = await FavoriteService.reorderGroups(payload.groups);
            if (response.status === 204) {
                await dispatch("loadGroups");
            }
        },
        async playItem(
            { dispatch },
            {
                groupId,
                item
            }
        ) {
            try {
                return await dispatch(
                    "media/play",
                    {
                        files: [item]
                    },
                    {
                        root: true
                    }
                );
            }
            catch (error) {
                if (
                    error.code === "FILE_NOT_FOUND" &&
                    groupId != null &&
                    item?.id != null
                ) {
                    await dispatch(
                        "deleteItem",
                        {
                            groupId,
                            itemId: item.id,
                            itemName: item.name,
                            autoDelete: true
                        }
                    );

                    return false;
                }

                throw error;
            }
        },
        async playGroup(
            { dispatch },
            {
                groupId,
                shuffle = false
            }
        ) {
            const items =
                await dispatch(
                    "loadItems",
                    groupId
                );

            if (!items?.length)
                return false;

            try {
                return await dispatch(
                    "media/play",
                    {
                        files: items,
                        shuffle
                    },
                    {
                        root: true
                    }
                );
            }
            catch (error) {
                if (error.code === "FILE_NOT_FOUND") {
                    // play()에서 첫 번째 파일을 재생하다 실패한 경우
                    const item = error.item;

                    if (item?.id != null) {
                        await dispatch(
                            "deleteItem",
                            {
                                groupId,
                                itemId: item.id,
                                itemName: item.name,
                                autoDelete: true
                            }
                        );
                    }

                    return false;
                }

                throw error;
            }
        },
        async markFilesMissing(
            { commit },
            { groupId, items }
        ) {
            for (const item of items) {
                if (item.id == null)
                    continue;

                try {
                    await FavoriteService.markFileMissing(
                        groupId,
                        item.id
                    );

                    commit("setItemFileExists", {
                        itemId: item.id,
                        fileExists: false
                    });
                }
                catch (error) {
                    console.error(
                        "markFilesMissing error:",
                        item,
                        error
                    );
                }
            }
        }
    }
};